(function () {
  function init(root) {
    if (!root || root.dataset.barefootSizeBannerReady === 'true') return;
    root.dataset.barefootSizeBannerReady = 'true';
    var button = root.querySelector('[data-barefoot-size-chart-trigger]');
    if (!button) return;
    button.addEventListener('click', function () {
      var existingTrigger = document.querySelector('[data-barefoot-root] [data-barefoot-modal-open]');
      if (existingTrigger) existingTrigger.click();
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-barefoot-size-banner]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
